import { ConsumptionUnitEnum } from '../../../enum/ConsumptionUnitEnum';
import React from 'react';
import classNames from 'classnames';

export interface UnitSelectorProps {
  className?: string;
  value?: ConsumptionUnitEnum;
  onChange?: (value: ConsumptionUnitEnum) => void;
}
export default function UnitSelector({ className, value, onChange }: UnitSelectorProps) {
  return (
    <ul className={classNames('unit-selector', className)}>
      {[ConsumptionUnitEnum.EURO, ConsumptionUnitEnum.KWH].map((item) => (
        <li
          onClick={() => onChange && onChange(item)}
          key={item}
          className={classNames('unit-selector__item', {
            'unit-selector__item--active': value === item,
          })}
        >
          {ConsumptionUnitEnum.getSymbol(item)}
        </li>
      ))}
    </ul>
  );
}
